import { render, staticRenderFns } from "./categoryInfo.vue?vue&type=template&id=48984558&scoped=true"
import script from "./categoryInfo.vue?vue&type=script&lang=js"
export * from "./categoryInfo.vue?vue&type=script&lang=js"
import style0 from "./categoryInfo.vue?vue&type=style&index=0&id=48984558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48984558",
  null
  
)

export default component.exports